// extracted by mini-css-extract-plugin
export default {"autoLogin":"index_autoLogin_BYhfl clearfix","checkBox":"index_checkBox_hzSsS","txt":"index_txt_GLReg","register":"index_register_1S-Xs"};